export const SET_CUSTOMER = 'SET_CUSTOMER';
export const SET_COMPANY_DATA = 'SET_COMPANY_DATA';
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD';
